import React from 'react';
import { motion } from 'framer-motion';

const PillBadge = ({
  text,
  icon,
  className = '',
  initial = { opacity: 0, y: 20 },
  animate = { opacity: 1, y: 0 },
  transition = { duration: 0.6 },
}) => {
  return (
    <motion.div
      initial={initial}
      animate={animate}
      transition={transition}
      className={`inline-flex items-center space-x-2 border border-white/15 bg-[#1E1E1E] text-white px-4 py-1 rounded-full ${className}`}
    >
      {text ? <span>{text}</span> : null}
      {icon ? <span className="text-yellow-400">{icon}</span> : null}
    </motion.div>
  );
};

export default PillBadge;


